import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Radio } from 'rmwc/Radio';
import {Button} from 'rmwc/Button';
import { Select } from 'rmwc/Select';
import PlacesAutoComplete from 'react-places-autocomplete'
import SerializeForm from 'form-serialize';
import GooglePlacesAutoComplete from './GooglePlacesAutoComplete'
import * as api from '../api/api';
import StatusMessage from '../util/StatusMessage'

class ContactInfo extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      save_disable: false,
      data:{
        'email': '',
        'mobile': '',
        'street': '',
        'locality': '',
        'city': '',
        'state_id': '',
        'state_name': '',
        'country_id': '',
        'country_name': '',
        'countries': [],
        'states': [],
      },
      formErrors:{
        phoneNumberError: '',
        countryIdError: '',
        emailError: '',
      },
    };
    this.handleCountriesChange = this.handleCountriesChange.bind(this)
    this.handleStatesChange = this.handleStatesChange.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
    this.handleCitySelect = this.handleCitySelect.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleLocalitySelect = this.handleLocalitySelect.bind(this)
    this.handleLocalityChange = this.handleLocalityChange.bind(this)
    this.validateForm = this.validateForm.bind(this)
    //this.getCountries = this.getCountries.bind(this)
  }

  componentDidMount() {

    let data = Object.assign({}, this.state.data)
    let address
    return api.getAddresses(this.props.user.accessToken)
      .then((result) => {
          if (result.user) {
            let user = result.user
            data.email = user.email?user.email:''
            data.mobile = user.phone
          }
          address = result.address
          if (result && result.address && result.address.id) {
            let address = result.address
            data.street = address.street?address.street:''
            data.locality = address.locality?address.locality:''
            data.city = address.city?address.city:''
          }
          return api.getCountries(this.props.user.accessToken)
          }).then((result) => {
            var countryToPass = ''
            data.countries = result
            if(address && address.country_id){
              data.country_id = address.country_id
              data.state_id = address.state_id?address.state_id:0
              countryToPass = address.country_id
            }
            else{
              countryToPass = data.countries[0].id
            }
 
            return api.getStates(this.props.user.accessToken, countryToPass)
            }).then((result) =>{
              data.states = result
              this.setState({data: data})
          })

  }


  handleCountriesChange(event) {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    if (optionElement)
      console.log("In handleCountriesChange : target = " + event.target.value + " " + optionElement.getAttribute('data-name'))

      let data = Object.assign({}, this.state.data)
      let countryChanged = false
      if(!event.target.value){
        console.log('inside target value for country undefined')
        data.country_id=''
        data.states=[]
        data.state_id=''
        this.setState({data: data})
        return
      }

      if (data.country_id === event.target.value)
        countryChanged = false
      else
        countryChanged = true
      data.country_id = event.target.value
      data.country_name = optionElement.getAttribute('data-name')
      if (countryChanged) {
        data.states=[]
        data.state_id=''
        
        api.getStates(this.props.user.accessToken, data.country_id)
        .then((states) => {
          console.log("GetStates");
          data.states = states
          this.setState({data: data})
        })
        this.props.checkForChange(event,true)
      } else {
        this.setState({data: data})
      }
  }

  handleStatesChange(event) {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    console.log("In handleStatesChange : target = " + event.target.value + " " + optionElement.getAttribute('data-name'))

    let data = Object.assign({}, this.state.data)
    data.state_id = event.target.value
    data.state_name = optionElement.getAttribute('data-name')
    this.setState({data: data})
    this.props.checkForChange(event,true)
  }

  handleCityChange(value) {
    let data = Object.assign({}, this.state.data)
    data.city = value
    this.setState({data: data})
    this.props.checkForChange('',true)
  }

  handleCitySelect(address) {
    let data = Object.assign({}, this.state.data)
    data.city = address
    this.setState({data: data})
    this.props.checkForChange('',true)
  }

  handleLocalityChange(value) {
    let data = Object.assign({}, this.state.data)
    data.locality = value
    this.setState({data: data})
    this.props.checkForChange('',true)
  }

  handleLocalitySelect(address) {
    
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
    this.props.checkForChange(evt,true)
  };

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    var phoneno = /^\d{7,22}$/;
    errorObj.phoneNumberError =''
    errorObj.countryIdError =''
    errorObj.emailError =''

    if(data.mobile !== '' && !data.mobile.match(phoneno)){
        errorObj.phoneNumberError ='Please enter a valid mobile number'
        error = false
    }
    

    if(data.country_id === '' ){
        errorObj.countryIdError ='Country is Mandatory'
        error = false
    }

    this.setState({
      formErrors:errorObj,
      errorMsg:''
    })

    return error
  }


  handleSubmit(e) {
    e.preventDefault()
    const values = SerializeForm(e.target, { hash: true })

    if(this.validateForm()){
      let apiInput = {
        'address':{
          'locality': values.locality,
          'street': values.street,
          'city': values.city,
          'state_id': values.state,
          'country_id': values.country,
        },
        'user':{
          'email': values.email,
          'phone': values.mobile
        }
      }
      this.setState({save_disable: true})
      api.saveContactInfo(this.props.user.accessToken,apiInput)
      .then((result) => {
        if(result.errors){
          this.setState({ errorMsg: result.errors, save_disable: false })
        }
        this.props.checkForChange('',false)
        this.setState({save_disable: false})
      })
      .catch((err) => {
      // console.log(`error:${err.stack}`)
        this.setState({ errorMsg: err.stack, save_disable: false })
      })
    }

  }

  render() {
    return <form  onSubmit={this.handleSubmit}>
      <TextField label="Email" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email}/>
      <TextField label="Mobile" autoComplete="off"  name="mobile" onChange={this.onInputChange} value={this.state.data.mobile}/>
      <div>
          <br/>
          <Select
            name="country"
            onChange={this.handleCountriesChange}
            value={this.state.data.country_id}
            className="select-component"
            placeholder="--Select Country--"
          >
            {this.state.data.countries.map(country => (
              <option key={country.id} value={country.id} data-name={country.name}>
                {country.name}
              </option>
            ))}
          </Select>
      </div>
      <br/>
      <div>
          {this.state.data.states.length !=0 &&
          <Select
            name="state"
            onChange={this.handleStatesChange}
            value={this.state.data.state_id}
            className="select-component"
          >
            {this.state.data.states.map(state => (
              <option key={state.id} value={state.id} data-name={state.name}>
                {state.name}
              </option>
            ))}
          </Select>
          }
      </div>
      <div>
          <GooglePlacesAutoComplete
          value={this.state.data.city}
          handleCityChange={this.handleCityChange}
          handleCitySelect={this.handleCitySelect}
          />
      </div>
      <PlacesAutoComplete
          value={this.state.data.locality}
          onChange={this.handleLocalityChange}
          onSelect={this.handleLocalitySelect}
          >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div>
            <TextField
              {...getInputProps({
                placeholder: 'Locality',
                className: 'location-search-input'
              })}
              name="locality"
            />
            <div className="autocomplete-dropdown-container">
              {suggestions.map(suggestion => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div {...getSuggestionItemProps(suggestion, { className, style })}>
                    <span>{suggestion.description}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
        </PlacesAutoComplete>

      
      <TextField label="Building/Street" autoComplete="off"  name="street" onChange={this.onInputChange} value={this.state.data.street}/>
      <br/><br/>
      <Button raised disabled={this.state.save_disable}>Save</Button>
      <StatusMessage error_msg = {this.state.formErrors.phoneNumberError}/>
      <StatusMessage error_msg = {this.state.formErrors.countryIdError}/>
      <StatusMessage error_msg = {this.state.errorMsg}/>
    </form>
  }
}

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/views/ContactInfo.jsx